module.exports = __webpack_public_path__ + "img/diretor.82980411.png";